import { RandomId } from "@swivl-mono/helpers";
import { NodeData_StoreFinderLookup, NodeInterface, VarKey } from "@swivl-mono/types";
import { Switch } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const StoreFinderLookup = {
  Type: "storeFinderLookup",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: StoreFinderLookup.Type,
      storeFoundGoto: "",
      storeNotSelectedGoto: "",
      missingParamsGoto: "",
      useURL: true,
      usePostalCode: true,
      useFMSId: true,
      showAllStores: false,
      filterStores: false
    } as NodeData_StoreFinderLookup;

    return node; //
  },
  PlumbData: function (node: NodeInterface) {
    let missingParamsTitle = "Missing: ";

    let missingItems: any = [];
    if (node.useURL) {
      missingItems.push("URL");
    }
    if (node.usePostalCode) {
      missingItems.push("Postal Code");
    }
    if (node.useFMSId) {
      missingItems.push("FMS Id");
    }
    if (missingItems.length > 1) {
      missingParamsTitle += missingItems.join(", ");
    } else {
      missingParamsTitle += missingItems[0];
    }
    // if (node.useURL && !node.usePostalCode) {
    //   missingParamsTitle= "Missing URL"
    // } else if (!node.useURL && node.usePostalCode) {
    //   missingParamsTitle= "Missing Zip"
    // } else if (node.useURL && node.usePostalCode) {
    //   missingParamsTitle= "Missing URL or Zip"
    // } else if {
    //   missingParamsTitle= "Missing FMS Id"
    // }

    const tabs = node.showAllStores
      ? [
          {
            id: "storeFoundGoto",
            source: "storeFoundGoto",
            target: node.storeFoundGoto,
            title: "Store Selected"
          }
        ]
      : [
          {
            id: "storeFoundGoto",
            source: "storeFoundGoto",
            target: node.storeFoundGoto,
            title: "Store Selected"
          },

          {
            id: "storeNotSelectedGoto",
            source: "storeNotSelectedGoto",
            target: node.storeNotSelectedGoto,
            title: "Text Input"
          },

          {
            id: "missingParamsGoto",
            source: "missingParamsGoto",
            target: node.missingParamsGoto,
            title: missingParamsTitle
          }
        ];

    return TabNodeLayoutData({
      node: node,
      title: "Find Store",
      baseWidth: 150,
      tabs: tabs
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props) {
      super(props);
      this.filterToggled = this.filterToggled.bind(this);
    }
    filterToggled(name: string, on: boolean) {
      let node: NodeData_StoreFinderLookup = { ...this.props.node } as NodeData_StoreFinderLookup;
      node.filterStores = on;
      if (on) {
        node.filterVariableId = VarKey.UserFilterFeatures;
      } else {
        delete node.filterVariableId;
      }
      this.props.updateNode(node, this.props.node);
    }

    render() {
      const node = this.props.node as NodeData_StoreFinderLookup;

      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Find Store" />
            <label>Criteria</label>

            {node.showAllStores ? (
              <></>
            ) : (
              <>
                <Switch
                  on={node.useFMSId}
                  name="useFMSId"
                  onSet={(on: boolean, name?: string) => this.onChangeSwitch(name!, on)}
                  label={"Lookup by User:Location"}
                />
                <br />
                <Switch
                  on={node.useURL}
                  name="useURL"
                  onSet={(on: boolean, name?: string) => this.onChangeSwitch(name!, on)}
                  label={"Lookup by URL"}
                />
                <br />
                <Switch
                  on={node.usePostalCode}
                  name="usePostalCode"
                  onSet={(on: boolean, name?: string) => this.onChangeSwitch(name!, on)}
                  label={"Lookup by Postal Code"}
                />
                <br />
              </>
            )}
            <Switch
              on={node.showAllStores}
              name="showAllStores"
              onSet={(on: boolean, name?: string) => this.onChangeSwitch(name!, on)}
              label={"Show All Stores"}
            />
            <br />
            <Switch
              on={node.filterStores || false}
              name="filterStores"
              onSet={(on: boolean, name?: string) => this.onChangeSwitch(name!, on)}
              label={"Filter Stores"}
            />
            <br />

            {node.filterStores && (
              <div>
                <label>Filter Variable</label>
                <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name="filterVariableId" value={node.filterVariableId} />
              </div>
            )}
          </div>
          <InspectorFooter deleteNode={this.deleteNode} node={node} />
        </div>
      );
    }
  }
};
export default StoreFinderLookup;
